import React, { useEffect } from "react";
import { App, ConfigProvider, Modal, Table } from "antd";
import { createRoot } from 'react-dom/client';
import { customTheme } from "common/customTheme";
import { EditableContextProvider } from "common/EditableContextProvider";
import { useContactList } from "../Hooks/useContactList";
import ErrorBox from "common/ErrorBox";

export default function Main({cat_user_id}) {
    const context = useContactList(cat_user_id);

    useEffect(() => {
        context.updateToken().then(() => {
            Promise.all([
                context.fillItems(),
                context.fillResources()
            ]);
        })
    }, []);

    return (
        <div>
            <EditableContextProvider data={{ context }} >
                <Table
                    title={() => (
                        <div className="d-flex justify-content-between">
                            <div className="px-3" style={{ fontSize: '1.25rem' }}>Categorías de clientes</div>
                            <div className="d-flex">
                                <button className="btn btn-sm btn-light border ms-2"
                                    onClick={() => context.importModal.open() }
                                >
                                    <i className="fas fa-table me-2"></i>
                                    Importar desde Excel
                                </button>
                                <button className="btn cat-btn-orange mx-3"
                                    onClick={() => context.newItem()}
                                >
                                    <i className="fas fa-plus me-2"></i>
                                    Añadir Nuevo
                                </button>
                            </div>
                        </div>
                    )}
                    {...context.getTableProps()}
                />
                { context.modalBase.contextModal }
                { context.importModal.contextModal }
            </EditableContextProvider>
        </div>
    )
}

let main = document.getElementById('contact-list-main');

if (main) {
    let cat_user_id = main.dataset.catUserId;
    if(!main.root) {
        main.root = createRoot(main);
        main.root.render(
            <React.StrictMode>
                <ErrorBox>
                    <ConfigProvider theme={customTheme}>
                        <App >
                            <Main cat_user_id={cat_user_id} />
                        </App>
                    </ConfigProvider>
                </ErrorBox>
            </React.StrictMode>
        );
    }
}
